import { AlertTriangle, X } from "lucide-react";
import React from "react";
import { useProductBranding } from "src/hooks/useProductBranding";

interface ThinkingContainerProps {
  isThinking: boolean;
  children: React.ReactNode;
  pendingMessage?: string | null;
  onStopAndSend?: () => void;
  onDismissWarning?: () => void;
  isStopAndSendPending?: boolean;
}

export const ThinkingContainer: React.FC<ThinkingContainerProps> = ({
  children,
  pendingMessage,
  onStopAndSend,
  onDismissWarning,
  isStopAndSendPending,
}) => {
  const { productName } = useProductBranding();

  const showWarning = !!pendingMessage;

  return (
    <div
      className={`
        rounded-lg border p-2 space-y-1
        ${showWarning
          ? "border-primary/50 bg-primary/10 shadow-[0_0_15px_rgba(46,154,255,0.3)]"
          : "border-transparent bg-transparent shadow-none"
        }
      `}
    >
      {/* Warning when user tries to submit while thinking */}
      {showWarning && (
        <div className="flex items-center gap-2 text-xs px-2 mb-2">
          <AlertTriangle className="w-3.5 h-3.5 text-amber-400 flex-shrink-0" />
          <span className="text-amber-200/80">{productName} is still thinking. Stop current response to send your message?</span>
          <button
            onClick={onStopAndSend}
            disabled={isStopAndSendPending}
            className="px-2 py-0.5 rounded bg-amber-500/20 hover:bg-amber-500/30 text-amber-200 font-medium transition-colors flex-shrink-0 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-amber-500/20"
          >
            {isStopAndSendPending ? "Stopping..." : "Stop & Send"}
          </button>
          <button
            onClick={onDismissWarning}
            disabled={isStopAndSendPending}
            className="p-0.5 rounded hover:bg-white/10 text-gray-400 hover:text-gray-300 transition-colors flex-shrink-0 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent"
            title="Dismiss"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      )}

      {/* Input */}
      <div>{children}</div>
    </div>
  );
};
